import React from "react"
import moment from "moment"
import "./calendar.css"
import styled from "styled-components"
import ArrowRight from "../../../../components/Images/ChevronRight"
import ArrowLeft from "../../../../components/Images/ChevronLeft"
import { months } from "../../constants"
import Streak from "../../../../components/Images/Streak"
import BlueClock from "../../../../components/Images/BlueClock"
import CrossDark from "../../../../components/Images/CrossDark"
import Tooltip from '../../../../CustomTooltip'
import InfoIcon from '../../../../components/Images/InfoIcon'

const ArrowRightIcon = styled(ArrowRight)`
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor:pointer;
  margin-left: 8px;
`

const ArrowLeftIcon = styled(ArrowLeft)`
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor:pointer;
  margin-right: 8px;
`

const ColorBlock = styled.div`
    width: 20px;
    height: 25px;
    margin-right: 4px;
    background-color: ${({ color }) => color};
`

const InfoBoxes = styled.div`
    display: flex;
    align-items: center;
`

const StreakIcon = styled(Streak)`
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  right: 0;
`
const ClockIcon = styled(BlueClock)`
  position: absolute;
  top: 0;
  left: 0;
`
const DateCell = styled.li`
  height: ${({ height }) => height || '36px'};
  grid-column-start: ${({ startDate }) => startDate || 'unset'};
  background-color:  ${({ bg }) => bg};
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`

const DateText = styled.span`
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color:  ${({ color }) => color};
  cursor: pointer;
`

const IncentiveAmount = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  color:  ${({ color }) => color};
`

const CrossIcon = styled(CrossDark)`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
`

export default class Calendar extends React.Component {
  weekdayshort = moment.weekdaysShort();

  state = {
    showCalendarTable: true,
    showMonthTable: false,
    dateObject: moment(),
    allmonths: moment.months(),
    showYearNav: false,
    selectedDay: null,
    previousSelectedDay : null,
    showLegend : true
  };

  daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  };

  year = () => {
    return this.state.dateObject.format("Y");
  };

  currentDay = () => {
    return this.state.dateObject.format("D");
  };

  firstDayOfMonth = () => {
    const dateObject = this.state.dateObject;
    const firstDay = moment(dateObject)
      .startOf("month")
      .format("d"); // Day of week 0...1..5...6
    return firstDay;
  };

  month = () => {
    return this.state.dateObject.format("MMMM");
  };

  showMonth = (e, month) => {
    this.setState({
      showMonthTable: !this.state.showMonthTable,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  setMonth = month => {
    const monthNo = this.state.allmonths.indexOf(month);
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("month", monthNo);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  MonthList = props => {
    const months = [];
    props.data.map(data => {
      months.push(
        <td
          key={data}
          className="calendar-month"
          onClick={e => {
            this.setMonth(data);
          }}
        >
          <span>{data}</span>
        </td>
      );
    });
    const rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i == 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    const monthlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Month</th>
          </tr>
        </thead>
        <tbody>{monthlist}</tbody>
      </table>
    );
  };

  showYearEditor = () => {
    this.setState({
      showYearNav: true,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  onPrev = () => {
    let curr = "";
    if (this.state.showMonthTable == true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.subtract(1, curr)
    });
  };

  onNext = () => {
    let curr = "";
    if (this.state.showMonthTable == true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.add(1, curr)
    });
  };

  setYear = year => {
    // alert(year)
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("year", year);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showYearNav: !this.state.showYearNav,
      showMonthTable: !this.state.showMonthTable
    });
  };

  onYearChange = e => {
    this.setYear(e.target.value);
  };

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY"));
      currentDate = moment(currentDate).add(1, "year");
    }
    return dateArray;
  }

  YearTable = props => {
    const months = [];
    const nextten = moment()
      .set("year", props)
      .add("year", 12)
      .format("Y");

    const tenyear = this.getDates(props, nextten);

    tenyear.map(data => {
      months.push(
        <td
          key={data}
          className="calendar-month"
          onClick={e => {
            this.setYear(data);
          }}
        >
          <span>{data}</span>
        </td>
      );
    });
    const rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i == 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    const yearlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Yeah</th>
          </tr>
        </thead>
        <tbody>{yearlist}</tbody>
      </table>
    );
  };
  
  onDayClick = (e, d) => {
    const el = document.getElementById(`calendar-day-${d}`)
    el.style.height = "58px";
    if(this.state.previousSelectedDay){
      const el1 = document.getElementById(`calendar-day-${this.state.previousSelectedDay}`)
      el1.style.height = "36px";
    }
    this.setState({
      previousSelectedDay : d,
      selectedDay : d
    })
  };

  increasetMonth = month => {
    if(this.state.previousSelectedDay){
      const el1 = document.getElementById(`calendar-day-${this.state.previousSelectedDay}`)
      el1.style.height = "36px";
    }
    let monthNo = this.state.allmonths.indexOf(month);
    monthNo++;
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("month", monthNo);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showPreviousMonthIcon : true,
      selectedDay: null,
      previousSelectedDay: null,
    });
  };

  decreasetMonth = month => {
    if(this.state.previousSelectedDay){
      const el1 = document.getElementById(`calendar-day-${this.state.previousSelectedDay}`)
      el1.style.height = "36px";
    }
    // if(new Date(this.state.dateObject).getMonth()!==new Date().getMonth() || new Date(this.state.dateObject).getFullYear()!==new Date().getFullYear())
    {
      let monthNo = this.state.allmonths.indexOf(month);
      monthNo--;
      let dateObject = Object.assign({}, this.state.dateObject);
      dateObject = moment(dateObject).set("month", monthNo);
      this.setState({
        dateObject: dateObject,
        showMonthTable: !this.state.showMonthTable,
        showPreviousMonthIcon : true,
        selectedDay: null,
        previousSelectedDay: null,
      });
    }
   
  };

  render() {
    const list = [
      <li className="day-name">Sun</li>,
      <li className="day-name">Mon</li>,
      <li className="day-name">Tue</li>,
      <li className="day-name">Wed</li>,
      <li className="day-name">Thu</li>,
      <li className="day-name">Fri</li>,
      <li className="day-name">Sat</li>
    ]
    const isMobile = window.screen.width <= 600
    const month = months.findIndex((mon) => mon === this.month().substr(0,3))
    const firstApprovedDate = new Date(this.props.wbpFirstOngoingDate)
    const isApprovedMonthAndYear = months[firstApprovedDate.getMonth()] === this.month().substr(0,3) && firstApprovedDate.getFullYear().toString() === this.year()
    for(let d =1;d<=this.daysInMonth();d++){
      const currentDay = d === (new Date()).getDate() && months[(new Date()).getMonth()] === this.month().substr(0,3) && (new Date()).getFullYear() ? "today" : "";
      const fullDate = `${("0" + d).slice(-2)}/${("0" + (month + 1)).slice(-2)}/${this.year()}`.toString()
      const dateObj = this.props?.publishedDates?.[fullDate]
      const showIncentiveAmount = currentDay || dateObj?.future_date ? false : dateObj?.incentive_type ? true : false
      const { incentive_type } = dateObj || {}
      const beforeApprovedDate = isApprovedMonthAndYear && d < firstApprovedDate.getDate()
      const bg = (incentive_type === 'full_incentive' ? '#c3ea69' : (incentive_type === 'streak_incentive' ? '#799e22' : (incentive_type === 'half_incentive' ? '#fbe565' : (incentive_type === 'missed_day' ? '#f7737b' : ''))))
      list.push(
        <DateCell 
          id={`calendar-day-${d}`}
          startDate={d === 1 && Number(this.firstDayOfMonth()) + 1}
          bg={bg}
          height={showIncentiveAmount && !isMobile && '58px'}
          onClick={e => {
            isMobile && showIncentiveAmount && this.onDayClick(e, d);
          }}
        >
          {dateObj?.streak_day && <StreakIcon />}
          {dateObj?.future_date && <ClockIcon />}
          <DateText color={beforeApprovedDate ? 'rgba(13, 21, 54, 0.3)' : currentDay ? '#068ae2' : dateObj?.incentive_type === 'missed_day' ? '#9f111a' : dateObj ? '#295e48' : 'rgba(13, 21, 54, 0.65)'} >
            {d}
            <br/>
            {showIncentiveAmount && !isMobile && <IncentiveAmount color={incentive_type === 'full_incentive' || incentive_type === 'streak_incentive' ? '#54b585' : incentive_type === 'missed_day' ? '#dd3623' : '#b9990b'}>{this.props?.isUgcBook ? '$' : '₹'}{Number.isInteger(dateObj?.incentive) ? dateObj?.incentive : (dateObj?.incentive).toFixed(2)}</IncentiveAmount>}
            {showIncentiveAmount && isMobile && this.state.selectedDay === d &&  <IncentiveAmount color={incentive_type === 'full_incentive' || incentive_type === 'streak_incentive' ? '#54b585' : incentive_type === 'missed_day' ? '#dd3623' : '#b9990b'}>{this.props?.isUgcBook ? '$' : '₹'}{Number.isInteger(dateObj?.incentive) ? dateObj?.incentive : (dateObj?.incentive).toFixed(2)}</IncentiveAmount>}
          </DateText>
        </DateCell>
      )
    }
    return (
      <div id="daily-calendar" className="daily-bonus-calendar">
        <div className="calendar-navi">
            {!isApprovedMonthAndYear && <ArrowLeftIcon onClick={()=>this.decreasetMonth(this.month())} />}
            {this.month()} {this.year()}
            <ArrowRightIcon onClick={()=>this.increasetMonth(this.month())}/>
        </div>
        
        {this.state.showCalendarTable && (
          <div id="calendar-box">
                <ol className="calendar" id="day-list">
                  {list}
                </ol>
          </div>
        )}

        {this.state.showLegend && <div className="calender-info">
          <CrossIcon onClick={() => this.setState({ showLegend : false })}/>
          <InfoBoxes>
              <ColorBlock color="#f7737b"></ColorBlock>
              <p className="color-text">Missed Days <Tooltip content="Days with no chapter publish" direction="right">
                <InfoIcon  color="rgba(13, 21, 54, 0.8)"/>
              </Tooltip></p>
              
          </InfoBoxes>
          <InfoBoxes>
              <ColorBlock color="#fbe565"></ColorBlock>
              <p className="color-text">Half Incentive <Tooltip content="Days the book receives half incentive in account to missing publish " direction="top">
                <InfoIcon color="rgba(13, 21, 54, 0.8)"/>
              </Tooltip></p>
              
          </InfoBoxes>
          <InfoBoxes>
              <ColorBlock color="#c3ea69"></ColorBlock>
              <p className="color-text">Full Incentive <Tooltip content="Days the book receives full incentive" direction="top">
                  <InfoIcon color="rgba(13, 21, 54, 0.8)"/>
                </Tooltip></p>
             
              
          </InfoBoxes>
          <InfoBoxes>
              <ColorBlock color="#799e22"></ColorBlock>
              <p className="color-text">Streak Incentive <Tooltip content="Days the book receives streak incentive as the book is maintaining a streak of more than 30 days of regular publishing." direction="left">
                <InfoIcon color="rgba(13, 21, 54, 0.8)"/>
              </Tooltip></p>
              
          </InfoBoxes>
        </div>}
      </div>
    );
  }
}